export const identifyUser = (userIdentity: object) => {
  if (!userIdentity) return;

  if (import.meta.client && window && window.exponea) {
    exponea.identify(userIdentity);
  }
};

export const anonymousUser = () => {
  if (import.meta.client && window && window.exponea) {
    exponea.anonymize();
  }
};

/**
 * verify user has accpted tracking cookies before loading exponea script
 */
export const exponeaTrackingConsent = useScriptTriggerConsent();
